// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yG_v","left":"styles_left__ijuRK"};